import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const CATEGORIES = [
  { slug: "presidencia", label: "Presidencia" },
  { slug: "congreso", label: "Congreso" },
  { slug: "estados", label: "Estados" },
  { slug: "congresos-estados", label: "Congresos de los Estados" },
  { slug: "opinion", label: "Opinión" },
  { slug: "internacional", label: "Internacional" },
];

export const POLL_TOPICS = [
  { key: "approval", label: "Aprobación Presidencial" },
  { key: "party_approval", label: "Aprobación por Partido" },
  { key: "governor_approval", label: "Aprobación por Gobernador" },
  { key: "candidates_2030", label: "Candidatos Presidenciales 2030" },
];

export const PARTY_COLORS = {
  MORENA: "#8B0000",
  PAN: "#1D3557",
  PRI: "#006341",
  MC: "#F58220",
  OTROS: "#777777",
  APROBACION: "#006341",
  DESAPROBACION: "#8B0000",
  NS: "#9E9E9E",
};
